import { OrganizationCodes } from '@revenuemarket/bank';
import { Flex } from '@revenuemarket/cds';
import { colorTokens, colors, overlayColors, theme } from '@revenuemarket/design';
import { Tag, Typography } from 'antd';

interface Props {
  organizationCode: OrganizationCodes;
  onClick: () => void;
  organizationName: string;
  connectionStatus?: 'CONNECTED' | 'DISCONNECTED';
  isHighlighted?: boolean;
}

const StatusText: React.FC<{
  connectionStatus?: 'CONNECTED' | 'DISCONNECTED';
}> = ({ connectionStatus }) => {
  if (connectionStatus === 'CONNECTED') {
    return <Tag color="success">연결됨</Tag>;
  }
  if (connectionStatus === 'DISCONNECTED') {
    return <Tag color="error">연결 오류</Tag>;
  }

  return <Tag color="default">연결 안됨</Tag>;
};

export const CardOrganizationItem: React.FC<Props> = ({
  organizationCode,
  organizationName,
  connectionStatus,
  isHighlighted,
  onClick,
}) => {
  return (
    <Flex
      style={{
        padding: '7px 16px',
        borderRadius: 6,
        border: `1px solid ${
          isHighlighted
            ? colorTokens.borderPrimary
            : connectionStatus === 'DISCONNECTED'
              ? theme.colorTokens.textDanger
              : colorTokens.borderDefault
        }`,
        backgroundColor: isHighlighted ? overlayColors.primary[16] : '',
        cursor: 'pointer',
      }}
      gap={16}
      align="center"
      onClick={() => {
        onClick();
      }}
    >
      <Flex gap={16} align="center">
        <div>
          <img
            src={`https://static.clobe.ai/logo__card-${organizationCode}.png`}
            alt={organizationName}
            style={{
              width: 24,
              height: 34,
            }}
          />
        </div>
        <Typography.Text
          style={{
            color: colors.grayscaleBlack,
          }}
        >
          {organizationName}
        </Typography.Text>
      </Flex>
      <StatusText connectionStatus={connectionStatus} />
    </Flex>
  );
};
